import { gql } from '@apollo/client'

export const LOCATION_ADDRESS_FRAGMENT = gql`
  fragment LocationAddress on LocationAddress {
    address
    city
    country
    countryIsoCode
    id
    latitude
    longitude
    phone
    state
    stateIsoCode
    zipCode
  }
`
